import { Button } from 'ui-v2/components/Button';
import Modal from 'ui-v2/components/Modal';
import { Typography } from 'ui-v2/components/Typography';
import { ErrorBottomSheetProps, ErrorUiTypeEnum } from 'ui-v2/types/Error';
import s from './ErrorBottomSheet.module.scss';
import Icon from '../../Icon/Icon';
import React from 'react';

export const ErrorBottomSheet: React.FunctionComponent<ErrorBottomSheetProps> = ({
  show,
  onClose,
  errObj,
  zIndex = 5,
  cta = [],
}) => {
  const getIconColor = () => {
    switch (errObj?.ui_type) {
      case ErrorUiTypeEnum.bottom_sheet_err:
        return 'negative';
      case ErrorUiTypeEnum.bottom_sheet_warn:
        return 'alert_dark';
      default:
        return 'alert_dark';
    }
  };

  return (
    <Modal
      show={show}
      head={{ show: true, onClose: onClose }}
      rootStyle={{ zIndex: zIndex }}
      variant="bottomSheet"
      customeBodyStyle={{ padding: '0px' }}
      animation={{ timeout: 'm', type: 'btt' }}
    >
      <div className={s.root}>
        <div className={s.content}>
          <div className={s.icon}>
            <Icon name="InfoCircleBold" height={48} width={48} color={getIconColor()} />
          </div>
          <div className={s.text}>
            <Typography label={errObj?.title} variant="h_3_bold" as="h1" />
            {errObj?.description && (
              <Typography label={errObj?.description} variant="body_3_regular" color="secondary" />
            )}
          </div>
        </div>
        <div className={s.btn}>
          {errObj?.cta?.length > 0 ? (
            errObj.cta.map((item, idx) => (
              <Button
                key={`${idx}^^@`}
                label={item?.label}
                onClick={() => {
                  item?.onClick();
                  onClose();
                }}
                variant="primary"
                fullWidth
              />
            ))
          ) : (
            <Button label="Close" fullWidth onClick={onClose} />
          )}
        </div>
      </div>
    </Modal>
  );
};
